import { render, staticRenderFns } from "./TermsFormOrganizer.vue?vue&type=template&id=e4d165d0&scoped=true&"
import script from "./TermsFormOrganizer.vue?vue&type=script&lang=js&"
export * from "./TermsFormOrganizer.vue?vue&type=script&lang=js&"
import style0 from "./TermsFormOrganizer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TermsFormOrganizer.vue?vue&type=style&index=1&id=e4d165d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d165d0",
  null
  
)

export default component.exports